/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import styled from 'styled-components';
import { Avatar } from '@material-ui/core';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { ICellRendererParams } from '@ag-grid-community/core';
import { transform } from '../utils/image';
import { Flex } from './Flex';

const FallbackIcon = styled(LocalOfferIcon)`
  padding: ${({ theme }) => theme.space[1]}px;
`;

const StyledAvatar = styled(Avatar)`
  && {
    height: 24px;
    width: 24px;
  }
`;

const ImageRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  return (
    <Flex justifyContent="center" alignItems="center" height="38px">
      <StyledAvatar
        src={
          value?.uri && transform(value.uri, 'w_50,h_50,c_thumb,f_auto,q_auto/')
        }
      >
        <FallbackIcon />
      </StyledAvatar>
    </Flex>
  );
};

export default ImageRenderer;
